import { v4 as uuidv4 } from 'uuid';
/** 生成uuid */
export const generateUuid = (prefix) => {
    const res = uuidv4();
    return prefix ? `${prefix}-${res}` : res;
};
/** 生成OFLow的uuid */
export const generateOFlowId = () => {
    return generateUuid('OFLOW');
};
/** 生成OFLow中canvas的uuid */
export const generateOFlowCanvasId = () => {
    return generateUuid('CANVAS');
};
/** 生成OFlow中canvas的节点uuid */
export const generateOFlowCanvasNodeId = () => {
    return generateUuid('NODE');
};
/** 生成OFlow中canvas的连线uuid */
export const generateOFlowCanvasEdgeId = () => {
    return generateUuid('EDGE');
};
export const generateOFlowCanvasGroupId = () => {
    return generateUuid('GROUP');
};
//# sourceMappingURL=uuid.js.map